import { handleAction } from 'redux-actions';
import actions from '../actions';

const { toggle } = actions.drawer;

const drawer = handleAction(toggle, state => ({ active: !state.active }), {
  active: false,
});

export default drawer;



// WEBPACK FOOTER //
// ./src/reducers/drawer.js